import { FC } from "react"
import { SubAdmin } from "../../../module/settings/containers/subAdmin/list"

export const SubAdminPage: FC = () => <SubAdmin />
